var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import _ from 'lodash';
//import {  debugError } from '../../../logging/DebugLogger';
import PropertyMetadata from './models/PropertyMetadata';
import { isIdentifierReferenceType, isIdentifierReferenceTypeArray, isModelType, isModelTypeArray } from '../../_mobxStateTree/MobxStateTreeHelpers';
import SnapshotsOfTypeMetadata from './models/SnapshotsOfTypeMetadata';
var ModelToSnapshotMapper = /** @class */ (function () {
    function ModelToSnapshotMapper(modelType) {
        this.modelType = modelType;
    }
    // ToDo: Optimize this to remove duplicates
    ModelToSnapshotMapper.prototype.mapMany = function (models) {
        var _this = this;
        var arrayOfMapArrays = models.map(function (x) { return _this.map(x, _this.modelType); });
        // merge maps with same model type
        var mergedByModelType = new Map();
        if (arrayOfMapArrays.length === 0) {
            return mergedByModelType;
        }
        // reduce to array of maps
        var arrayOfMaps = arrayOfMapArrays.reduce(function (prev, current) { return __spreadArray(__spreadArray([], __read(prev), false), __read(current), false); });
        arrayOfMaps.forEach(function (map) {
            map.forEach(function (value, key) {
                var array = mergedByModelType.get(key);
                if (!array) {
                    array = [];
                    mergedByModelType.set(key, array);
                }
                array.push.apply(array, __spreadArray([], __read(value), false));
            });
        });
        return mergedByModelType;
    };
    ModelToSnapshotMapper.prototype.mapSingle = function (model) {
        return this.map(model, this.modelType);
    };
    ModelToSnapshotMapper.prototype.map = function (model, modelType, snapshots, createSnapshotForPassedModel, level) {
        var _this = this;
        if (snapshots === void 0) { snapshots = []; }
        if (createSnapshotForPassedModel === void 0) { createSnapshotForPassedModel = true; }
        if (level === void 0) { level = 0; }
        // if model is falsy => nothing to do
        if (!model) {
            return this.sortAndReturnMap(snapshots);
            ;
        }
        // if snapshots already contains a snapshot for this model ==> nothing to do
        var snapshotsOfType = createSnapshotForPassedModel ? this.getSnapshotsOfType(snapshots, modelType, level) : [];
        var currentIdentifier = model.id;
        if (snapshotsOfType.find(function (x) { return x.id === currentIdentifier; })) {
            return this.sortAndReturnMap(snapshots);
            ;
        }
        // get all properties of model which are identity references or arrays of identity references or models or arrays of models
        var modelAndReferenceProperties = this.getModelAndReferencePropertiesOfModel(model, modelType);
        modelAndReferenceProperties.forEach(function (propertyMetadata) {
            if (propertyMetadata.isIdentifierReference) {
                // map its properties
                _this.map(propertyMetadata.propertyValue, propertyMetadata.propertyType.targetType || (propertyMetadata.propertyType._types[0]).targetType, snapshots, true, level + 1);
                // replace with identifier
                model[propertyMetadata.propertyName] = propertyMetadata.propertyValue.id;
            }
            else if (propertyMetadata.isIdentifierReferenceArray) {
                propertyMetadata.propertyValue.forEach(function (reference, index) {
                    // map its properties
                    _this.map(reference, propertyMetadata.propertyType._subtype._subType.targetType, snapshots, true, level + 1);
                    // replace with identifier
                    model[propertyMetadata.propertyName][index] = reference.id;
                });
            }
            else if (propertyMetadata.isModel) {
                // map its properties
                _this.map(propertyMetadata.propertyValue, propertyMetadata.propertyType, snapshots, false, level + 1);
            }
            else if (propertyMetadata.isModelArray) {
                // _types[0] is used when we have types.maybeNull
                var arrayType_1 = propertyMetadata.propertyType._subtype || propertyMetadata.propertyType._types[0];
                propertyMetadata.propertyValue.forEach(function (x) {
                    // map its properties
                    // ToDo: support types.maybe(types.array(...))
                    try {
                        _this.map(x, arrayType_1._subType, snapshots, false, level + 1);
                    }
                    catch (_a) {
                        console.error(x, propertyMetadata);
                    }
                });
            }
        });
        if (createSnapshotForPassedModel) {
            snapshotsOfType.push(model);
        }
        return this.sortAndReturnMap(snapshots);
    };
    ModelToSnapshotMapper.prototype.sortAndReturnMap = function (snapshots) {
        var sortAndReturnMapResult = _.orderBy(snapshots, function (x) { return x.level; }, 'desc')
            .map(function (x) { return new Map().set(x.modelType, x.snapshots); });
        return sortAndReturnMapResult;
    };
    ModelToSnapshotMapper.prototype.getSnapshotsOfType = function (snapshotsOfTypesMetadata, modelType, level) {
        var snapshotsOfTypeMetadata = snapshotsOfTypesMetadata.find(function (x) { return x.modelType === modelType; });
        if (!snapshotsOfTypeMetadata) {
            snapshotsOfTypeMetadata = new SnapshotsOfTypeMetadata(modelType, [], level);
            snapshotsOfTypesMetadata.push(snapshotsOfTypeMetadata);
        }
        else if (level > snapshotsOfTypeMetadata.level) {
            snapshotsOfTypeMetadata.level = level;
        }
        return snapshotsOfTypeMetadata.snapshots;
    };
    ModelToSnapshotMapper.prototype.getModelAndReferencePropertiesOfModel = function (model, modelType) {
        var result = [];
        for (var propertyName in model) {
            var propertyValue = model[propertyName];
            // if model property is falsy or the model has no properties => it is not an object => ignore it
            if (!propertyValue || !modelType || !modelType.properties) {
                continue;
            }
            var propertyType = modelType.properties[propertyName];
            // if the property is not part of the model type ==> we have an problem, because this can not happen (than you have passed the wrong type)
            if (!propertyType) {
                /*debugError(`Error in ModelToSnapshotMapper.getIdentityReferencePropertiesOfModel: The property ${propertyName} is not part of the model type. Please check your mapping and the passed type!`, {
                  model, modelType
                });*/
                continue;
            }
            // if the property is an identity reference
            if (isIdentifierReferenceType(propertyType)) {
                result.push(new PropertyMetadata(propertyName, propertyValue, propertyType, 'identifierReference'));
            }
            else if (isIdentifierReferenceTypeArray(propertyType)) {
                result.push(new PropertyMetadata(propertyName, propertyValue, propertyType, 'identifierReferenceArray'));
            }
            else if (isModelType(propertyType)) {
                result.push(new PropertyMetadata(propertyName, propertyValue, propertyType, 'model'));
            }
            else if (isModelTypeArray(propertyType)) {
                result.push(new PropertyMetadata(propertyName, propertyValue, propertyType, 'modelArray'));
            }
        }
        return result;
    };
    return ModelToSnapshotMapper;
}());
export default ModelToSnapshotMapper;
//# sourceMappingURL=ModelToSnapshotMapper.js.map